import { useMutation } from '@tanstack/react-query'

import { messageApi } from '../api/messageApi'
import { MESSAGE_TYPE } from '../models/Message.enums'

export const useCreateConversationMutation = (userId: number) =>
  useMutation({
    mutationFn: (text: string) =>
      messageApi.createMessage({ type: MESSAGE_TYPE.TEXT, users: [userId], payload: { text } }),
  })
